export const ANIMATED_ASSETS = [
  {
    name: 'Ship_battle',
    animations: [
      { value: '0', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '1', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '2', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '3', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '4', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '5', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '6', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '7', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '8', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '9', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '10', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '11', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] },
      { value: '12', animation: ['ships-battle-Fix-fire', 'ships-battle-end'] }
    ]
  },
  {
    name: 'dock1',
    animations: [
      { value: '0', animation: ['flag-1-green'] },
      { value: '1', animation: ['flag-1-green'] },
      { value: '2', animation: ['flag-1-green'] },
      { value: '3', animation: ['flag-2-blue'] },
      { value: '4', animation: ['flag-2-blue'] },
      { value: '5', animation: ['flag-2-blue'] },
      { value: '6', animation: ['flag-3-yellow'] },
      { value: '7', animation: ['flag-3-yellow'] },
      { value: '8', animation: ['flag-3-yellow'] },
      { value: '9', animation: ['flag-4-red'] },
      { value: '10', animation: ['flag-4-red'] },
      { value: '11', animation: ['flag-5-black'] },
      { value: '12', animation: ['flag-5-black'] }
    ]
  },
  {
    name: 'ship_1',
    animations: [
      { value: '0', animation: ['ship_1_idleFlag'] },
      { value: '1', animation: ['ship_1_idleFlag'] },
      { value: '2', animation: ['ship_1_idleFlag'] },
      { value: '3', animation: ['ship_1_idleFlag'] },
      { value: '4', animation: ['ship_1_idleFlag'] },
      { value: '5', animation: ['ship_1_idleFlag'] },
      { value: '6', animation: ['ship_1_idleFlag'] },
      { value: '7', animation: ['ship_1_idleFlag'] },
      { value: '8', animation: ['ship_1_idleFlag'] },
      { value: '9', animation: ['ship_1_idleFlag'] },
      { value: '10', animation: ['ship_1_idleFlag'] },
      { value: '11', animation: ['ship_1_idleFlag'] },
      { value: '12', animation: ['ship_1_idleFlag'] }
    ]
  },
  {
    name: 'Ship_2',
    animations: [
      { value: '0', animation: ['ship_2_idleFlag'] },
      { value: '1', animation: ['ship_2_idleFlag'] },
      { value: '2', animation: ['ship_2_idleFlag'] },
      { value: '3', animation: ['ship_2_idleFlag'] },
      { value: '4', animation: ['ship_2_idleFlag'] },
      { value: '5', animation: ['ship_2_idleFlag'] },
      { value: '6', animation: ['ship_2_idleFlag'] },
      { value: '7', animation: ['ship_2_idleFlag'] },
      { value: '8', animation: ['ship_2_idleFlag'] },
      { value: '9', animation: ['ship_2_idleFlag'] },
      { value: '10', animation: ['ship_2_idleFlag'] },
      { value: '11', animation: ['ship_2_idleFlag'] },
      { value: '12', animation: ['ship_2_idleFlag'] }
    ]
  },
  {
    name: 'Ship_3',
    animations: [
      { value: '0', animation: ['ship_3_workingFlag'] },
      { value: '1', animation: ['ship_3_workingFlag'] },
      { value: '2', animation: ['ship_3_workingFlag'] },
      { value: '3', animation: ['ship_3_workingFlag'] },
      { value: '4', animation: ['ship_3_workingFlag'] },
      { value: '5', animation: ['ship_3_workingFlag'] },
      { value: '6', animation: ['ship_3_workingFlag'] },
      { value: '7', animation: ['ship_3_workingFlag'] },
      { value: '8', animation: ['ship_3_workingFlag'] },
      { value: '9', animation: ['ship_3_idleSailsUpFlag'] },
      { value: '10', animation: ['ship_3_idleSailsUpFlag'] },
      { value: '11', animation: ['ship_3_idleSailsUpFlag'] },
      { value: '12', animation: ['ship_3_idleSailsUpFlag'] }
    ]
  },
  {
    name: 'Ship_2_orange',
    animations: [
      { value: '0', animation: ['ship_2_workingFlag'] },
      { value: '1', animation: ['ship_2_workingFlag'] },
      { value: '2', animation: ['ship_2_workingFlag'] },
      { value: '3', animation: ['ship_2_workingFlag'] },
      { value: '4', animation: ['ship_2_workingFlag'] },
      { value: '5', animation: ['ship_2_workingFlag'] },
      { value: '6', animation: ['ship_2_workingFlag'] },
      { value: '7', animation: ['ship_2_workingFlag'] },
      { value: '8', animation: ['ship_2_workingFlag'] },
      { value: '9', animation: ['ship_2_idleSailsUpFlag'] },
      { value: '10', animation: ['ship_2_idleSailsUpFlag'] },
      { value: '11', animation: ['ship_2_idleSailsUpFlag'] },
      { value: '12', animation: ['ship_2_idleSailsUpFlag'] }
    ]
  },
  {
    name: 'Boat_1',
    animations: [
      { value: '0', animation: ['boat-1-float'] },
      { value: '1', animation: ['boat-1-float'] },
      { value: '2', animation: ['boat-1-float'] },
      { value: '3', animation: ['boat-1-float'] },
      { value: '4', animation: ['boat-1-float'] },
      { value: '5', animation: ['boat-1-float'] },
      { value: '6', animation: ['boat-1-float'] },
      { value: '7', animation: ['boat-1-float'] },
      { value: '8', animation: ['boat-1-float'] },
      { value: '9', animation: ['boat-1-float'] },
      { value: '10', animation: ['boat-1-float'] },
      { value: '11', animation: ['boat-1-float'] },
      { value: '12', animation: ['boat-1-float'] }
    ]
  },
  {
    name: 'raft-1',
    animations: [
      { value: '0', animation: ['raft-1-float'] },
      { value: '1', animation: ['raft-1-float'] },
      { value: '2', animation: ['raft-1-float'] },
      { value: '3', animation: ['raft-1-float'] },
      { value: '4', animation: ['raft-1-float'] },
      { value: '5', animation: ['raft-1-float'] },
      { value: '6', animation: ['raft-1-float'] },
      { value: '7', animation: ['raft-1-float'] },
      { value: '8', animation: ['raft-1-float'] },
      { value: '9', animation: ['raft-1-float'] },
      { value: '10', animation: ['raft-1-float'] },
      { value: '11', animation: ['raft-1-float'] },
      { value: '12', animation: ['raft-1-float'] }
    ]
  },
  {
    name: 'boat-6',
    animations: [
      { value: '0', animation: ['boat-6-float'] },
      { value: '1', animation: ['boat-6-float'] },
      { value: '2', animation: ['boat-6-float'] },
      { value: '3', animation: ['boat-6-float'] },
      { value: '4', animation: ['boat-6-float'] },
      { value: '5', animation: ['boat-6-float'] },
      { value: '6', animation: ['boat-6-float'] },
      { value: '7', animation: ['boat-6-float'] },
      { value: '8', animation: ['boat-6-float'] },
      { value: '9', animation: ['boat-6-float'] },
      { value: '10', animation: ['boat-6-float'] },
      { value: '11', animation: ['boat-6-float'] },
      { value: '12', animation: ['boat-6-float'] }
    ]
  },
  {
    name: 'Boat-7',
    animations: [
      { value: '0', animation: ['Boat-7-float'] },
      { value: '1', animation: ['Boat-7-float'] },
      { value: '2', animation: ['Boat-7-float'] },
      { value: '3', animation: ['Boat-7-float'] },
      { value: '4', animation: ['Boat-7-float'] },
      { value: '5', animation: ['Boat-7-float'] },
      { value: '6', animation: ['Boat-7-float'] },
      { value: '7', animation: ['Boat-7-float'] },
      { value: '8', animation: ['Boat-7-float'] },
      { value: '9', animation: ['Boat-7-float'] },
      { value: '10', animation: ['Boat-7-float'] },
      { value: '11', animation: ['Boat-7-float'] },
      { value: '12', animation: ['Boat-7-float'] }
    ]
  },
  {
    name: 'raft-2',
    animations: [
      { value: '0', animation: ['raft-2-float'] },
      { value: '1', animation: ['raft-2-float'] },
      { value: '2', animation: ['raft-2-float'] },
      { value: '3', animation: ['raft-2-float'] },
      { value: '4', animation: ['raft-2-float'] },
      { value: '5', animation: ['raft-2-float'] },
      { value: '6', animation: ['raft-2-float'] },
      { value: '7', animation: ['raft-2-float'] },
      { value: '8', animation: ['raft-2-float'] },
      { value: '9', animation: ['raft-2-float'] },
      { value: '10', animation: ['raft-2-float'] },
      { value: '11', animation: ['raft-2-float'] },
      { value: '12', animation: ['raft-2-float'] }
    ]
  },
  {
    name: 'boat-4',
    animations: [
      { value: '0', animation: ['boat-4-float'] },
      { value: '1', animation: ['boat-4-float'] },
      { value: '2', animation: ['boat-4-float'] },
      { value: '3', animation: ['boat-4-float'] },
      { value: '4', animation: ['boat-4-float'] },
      { value: '5', animation: ['boat-4-float'] },
      { value: '6', animation: ['boat-4-float'] },
      { value: '7', animation: ['boat-4-float'] },
      { value: '8', animation: ['boat-4-float'] },
      { value: '9', animation: ['boat-4-float'] },
      { value: '10', animation: ['boat-4-float'] },
      { value: '11', animation: ['boat-4-float'] },
      { value: '12', animation: ['boat-4-float'] }
    ]
  },
  {
    name: 'tradetent1',
    animations: [
      { value: '0', animation: ['TradeTentDonkeyIdle'] },
      { value: '1', animation: ['TradeTentDonkeyIdle'] },
      { value: '2', animation: ['TradeTentDonkeyIdle'] },
      { value: '3', animation: ['TradeTentDonkeyIdle'] },
      { value: '4', animation: ['TradeTentDonkeyIdle'] },
      { value: '5', animation: ['TradeTentDonkeyIdle'] },
      { value: '6', animation: ['TradeTentDonkeyIdle'] },
      { value: '7', animation: ['TradeTentDonkeyIdle'] },
      { value: '8', animation: ['TradeTentDonkeyIdle'] },
      { value: '9', animation: ['TradeTentDonkeyIdle'] },
      { value: '10', animation: ['TradeTentDonkeyIdle'] },
      { value: '11', animation: ['TradeTentDonkeyIdle'] },
      { value: '12', animation: ['TradeTentDonkeyIdle'] }
    ]
  },
  {
    name: 'waterWave1',
    animations: [
      { value: '0', animation: ['animation'] },
      { value: '1', animation: ['animation'] },
      { value: '2', animation: ['animation'] },
      { value: '3', animation: ['animation'] },
      { value: '4', animation: ['animation'] },
      { value: '5', animation: ['animation'] },
      { value: '6', animation: ['animation'] },
      { value: '7', animation: ['animation'] },
      { value: '8', animation: ['animation'] },
      { value: '9', animation: ['animation'] },
      { value: '10', animation: ['animation'] },
      { value: '11', animation: ['animation'] },
      { value: '12', animation: ['animation'] }
    ]
  },
  {
    name: 'waterWave2',
    animations: [
      { value: '0', animation: ['animation'] },
      { value: '1', animation: ['animation'] },
      { value: '2', animation: ['animation'] },
      { value: '3', animation: ['animation'] },
      { value: '4', animation: ['animation'] },
      { value: '5', animation: ['animation'] },
      { value: '6', animation: ['animation'] },
      { value: '7', animation: ['animation'] },
      { value: '8', animation: ['animation'] },
      { value: '9', animation: ['animation'] },
      { value: '10', animation: ['animation'] },
      { value: '11', animation: ['animation'] },
      { value: '12', animation: ['animation'] }
    ]
  },
  {
    name: 'waterWave3',
    animations: [
      { value: '0', animation: ['animation'] },
      { value: '1', animation: ['animation'] },
      { value: '2', animation: ['animation'] },
      { value: '3', animation: ['animation'] },
      { value: '4', animation: ['animation'] },
      { value: '5', animation: ['animation'] },
      { value: '6', animation: ['animation'] },
      { value: '7', animation: ['animation'] },
      { value: '8', animation: ['animation'] },
      { value: '9', animation: ['animation'] },
      { value: '10', animation: ['animation'] },
      { value: '11', animation: ['animation'] },
      { value: '12', animation: ['animation'] }
    ]
  },
  {
    name: 'waterWave4',
    animations: [
      { value: '0', animation: ['animation'] },
      { value: '1', animation: ['animation'] },
      { value: '2', animation: ['animation'] },
      { value: '3', animation: ['animation'] },
      { value: '4', animation: ['animation'] },
      { value: '5', animation: ['animation'] },
      { value: '6', animation: ['animation'] },
      { value: '7', animation: ['animation'] },
      { value: '8', animation: ['animation'] },
      { value: '9', animation: ['animation'] },
      { value: '10', animation: ['animation'] },
      { value: '11', animation: ['animation'] },
      { value: '12', animation: ['animation'] }
    ]
  },
  {
    name: 'sawmill',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'iron_mine',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'iron_ore_smelter',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'Silver_Smelter',
    animations: [
      { value: '0', animation: ['idle'] },
      { value: '1', animation: ['idle'] },
      { value: '2', animation: ['idle'] },
      { value: '3', animation: ['idle'] },
      { value: '4', animation: ['idle'] },
      { value: '5', animation: ['idle'] },
      { value: '6', animation: ['idle'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['idle'] },
      { value: '9', animation: ['idle'] },
      { value: '10', animation: ['idle'] },
      { value: '11', animation: ['idle'] },
      { value: '12', animation: ['idle'] }
    ]
  },
  {
    name: 'manor',
    animations: [
      { value: '0', animation: ['idle'] },
      { value: '1', animation: ['idle'] },
      { value: '2', animation: ['idle'] },
      { value: '3', animation: ['idle'] },
      { value: '4', animation: ['idle'] },
      { value: '5', animation: ['idle'] },
      { value: '6', animation: ['idle'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['idle'] },
      { value: '9', animation: ['idle'] },
      { value: '10', animation: ['idle'] },
      { value: '11', animation: ['idle'] },
      { value: '12', animation: ['idle'] }
    ]
  },
  {
    name: 'ToyMaster',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'TownHall',
    animations: [
      { value: '0', animation: ['idle'] },
      { value: '1', animation: ['idle'] },
      { value: '2', animation: ['idle'] },
      { value: '3', animation: ['idle'] },
      { value: '4', animation: ['idle'] },
      { value: '5', animation: ['idle'] },
      { value: '6', animation: ['idle'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['idle'] },
      { value: '9', animation: ['idle'] },
      { value: '10', animation: ['idle'] },
      { value: '11', animation: ['idle'] },
      { value: '12', animation: ['idle'] }
    ]
  },
  {
    name: 'Coal_Mine',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'plantation_2',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'blacksmith',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'Gold_Mill',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'Gold_Mine',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'Jewelry',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'PearlDiverCampPacked',
    animations: [
      { value: '0', animation: ['idle'] },
      { value: '1', animation: ['idle'] },
      { value: '2', animation: ['idle'] },
      { value: '3', animation: ['idle'] },
      { value: '4', animation: ['idle'] },
      { value: '5', animation: ['idle'] },
      { value: '6', animation: ['idle'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['idle'] },
      { value: '9', animation: ['idle'] },
      { value: '10', animation: ['idle'] },
      { value: '11', animation: ['idle'] },
      { value: '12', animation: ['idle'] }
    ]
  },
  {
    name: 'ceramic_workshop',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'glass_workshop',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['idle'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'tavern',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'sand_quarry',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'clay_quarry',
    animations: [
      { value: '0', animation: ['active'] },
      { value: '1', animation: ['active'] },
      { value: '2', animation: ['active'] },
      { value: '3', animation: ['active'] },
      { value: '4', animation: ['active'] },
      { value: '5', animation: ['active'] },
      { value: '6', animation: ['active'] },
      { value: '7', animation: ['active'] },
      { value: '8', animation: ['active'] },
      { value: '9', animation: ['active'] },
      { value: '10', animation: ['active'] },
      { value: '11', animation: ['active'] },
      { value: '12', animation: ['active'] }
    ]
  },
  {
    name: 'PlatinaMine',
    animations: [
      { value: '0', animation: ['abandoned'] },
      { value: '1', animation: ['abandoned'] },
      { value: '2', animation: ['abandoned'] },
      { value: '3', animation: ['abandoned'] },
      { value: '4', animation: ['abandoned'] },
      { value: '5', animation: ['abandoned'] },
      { value: '6', animation: ['abandoned'] },
      { value: '7', animation: ['abandoned'] },
      { value: '8', animation: ['abandoned'] },
      { value: '9', animation: ['abandoned'] },
      { value: '10', animation: ['abandoned'] },
      { value: '11', animation: ['abandoned'] },
      { value: '12', animation: ['abandoned'] }
    ]
  },
  {
    name: 'Silver_Mine',
    animations: [
      { value: '0', animation: ['abandoned'] },
      { value: '1', animation: ['abandoned'] },
      { value: '2', animation: ['abandoned'] },
      { value: '3', animation: ['abandoned'] },
      { value: '4', animation: ['abandoned'] },
      { value: '5', animation: ['abandoned'] },
      { value: '6', animation: ['abandoned'] },
      { value: '7', animation: ['abandoned'] },
      { value: '8', animation: ['abandoned'] },
      { value: '9', animation: ['abandoned'] },
      { value: '10', animation: ['abandoned'] },
      { value: '11', animation: ['abandoned'] },
      { value: '12', animation: ['abandoned'] }
    ]
  },
  {
    name: 'PlatinaSmelter',
    animations: [
      { value: '0', animation: ['abandoned'] },
      { value: '1', animation: ['abandoned'] },
      { value: '2', animation: ['abandoned'] },
      { value: '3', animation: ['abandoned'] },
      { value: '4', animation: ['abandoned'] },
      { value: '5', animation: ['abandoned'] },
      { value: '6', animation: ['abandoned'] },
      { value: '7', animation: ['abandoned'] },
      { value: '8', animation: ['abandoned'] },
      { value: '9', animation: ['abandoned'] },
      { value: '10', animation: ['abandoned'] },
      { value: '11', animation: ['abandoned'] },
      { value: '12', animation: ['abandoned'] }
    ]
  },
  {
    name: 'The witch_s Forest',
    animations: [
      { value: '0', animation: ['1'] },
      { value: '1', animation: ['1'] },
      { value: '2', animation: ['1'] },
      { value: '3', animation: ['1'] },
      { value: '4', animation: ['1'] },
      { value: '5', animation: ['1'] },
      { value: '6', animation: ['1'] },
      { value: '7', animation: ['1'] },
      { value: '8', animation: ['1'] },
      { value: '9', animation: ['1'] },
      { value: '10', animation: ['1'] },
      { value: '11', animation: ['1'] },
      { value: '12', animation: ['1'] }
    ]
  }
];

export enum PalmAnimations {
  IDLE = '1_idle',
  SLOW = '2_slow',
  NORMAL = '3_normal',
  FAST = '4_fast',
  STORM = '5_storm'
}

const palmAnimations = [
  { value: '0', animation: [PalmAnimations.IDLE] },
  { value: '1', animation: [PalmAnimations.IDLE] },
  { value: '2', animation: [PalmAnimations.IDLE] },
  { value: '3', animation: [PalmAnimations.SLOW] },
  { value: '4', animation: [PalmAnimations.SLOW] },
  { value: '5', animation: [PalmAnimations.NORMAL] },
  { value: '6', animation: [PalmAnimations.NORMAL] },
  { value: '7', animation: [PalmAnimations.NORMAL] },
  { value: '8', animation: [PalmAnimations.FAST] },
  { value: '9', animation: [PalmAnimations.FAST] },
  { value: '10', animation: [PalmAnimations.FAST] },
  { value: '11', animation: [PalmAnimations.STORM] },
  { value: '12', animation: [PalmAnimations.STORM] }
];

export const palms = [
  {
    name: 'palm1',
    skelData: '/assets/animations/palm1.skel',
    animations: palmAnimations
  },
  {
    name: 'palm2',
    skelData: '/assets/animations/palm2.skel',
    animations: palmAnimations
  },
  {
    name: 'palm3',
    skelData: '/assets/animations/palm3.skel',
    animations: palmAnimations
  },
  {
    name: 'palm4',
    skelData: '/assets/animations/palm4.skel',
    animations: palmAnimations
  },
  {
    name: 'palm5',
    skelData: '/assets/animations/palm5.skel',
    animations: palmAnimations
  },
  {
    name: 'palm6',
    skelData: '/assets/animations/palm6.skel',
    animations: palmAnimations
  },
  {
    name: 'palm7',
    skelData: '/assets/animations/palm7.skel',
    animations: palmAnimations
  },
  {
    name: 'palm8',
    skelData: '/assets/animations/palm8.skel',
    animations: palmAnimations
  }
];
